module.exports = __webpack_public_path__ + "img/Signs2.6e2fef8c.jpg";